import React from "react";
import { Modal, Button, Card } from "react-bootstrap";

export default function ConfirmDeleteModal({show, handleHide, organization, affiliateMember}){
  return (
    <Modal show={show} onHide={handleHide}>
      <Card className="mb-0">
        <Card.Header closeButton>
          <div>Delete {affiliateMember.name}</div>
        </Card.Header>
        <Card.Body>
          <p className="px-3 pt-3">
          Are you sure you want to delete this member? Deleting a member <b>CAN NOT BE UNDONE</b>.
          </p>
          <p className="px-3 pb-3">
          If this member has any forms, facilities, payments, invoices, documents, or anything else associated with their name, ALL OF THESE will be deleted by clicking the delete button."
          </p>
          <div className="d-flex align-items-center pl-3 pr-3 pb-3 justify-content-end">
            <div className="btn btn-outline-secondary" onClick={handleHide}>
              No, keep this member
            </div>
            <Button 
              className='btn-danger ml-3'
              variant="danger"
              href={`/organizations/${organization.name}/affiliate_members/${affiliateMember.id}`}
              data-method="delete">
              Yes, DELETE Forever.
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Modal>
  );
}